<template>
    <div class="container" style="">
        <div v-if="errorMessage" class="qlik-error-banner">
            <strong>Error cargando el reporte de Qlik:</strong>
            <pre>{{ errorMessage }}</pre>
        </div>
        <qlik-embed
            v-if="appId && sheetId"
            ref="qlikEmbedEl"
            class="classic-app"
            ui="classic/app"
            :app-id="appId"
            :sheet-id="sheetId"
            data-no-toolbar="true"
            opt=notoolbar
            clear-selections="'true'"
            context___json="{interactions:{active: false, select: false, passive: false}}"
        ></qlik-embed>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                qlikHost: "",
                appId: null,
                sheetId: null,
                errorMessage: null
            }
        },
        methods:{
            obtenerNombreInforme(){
                return this.$route.path.split('/').filter(Boolean).pop();
            },
            async cargarConfiguracionQlik(){
                const nombreInforme = this.obtenerNombreInforme();
                try{
                    console.log(`Obteniendo configuración de Qlik para el informe "${nombreInforme}"...`);
                    const result = await this.$store.getters.api(`qlik-config/${nombreInforme}`, {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('token')}`
                        }
                    });
                    this.appId = result.data.appId;
                    this.sheetId = result.data.sheetId;
                    return true;
                }catch(error){
                    const response = error && error.response ? error.response : {};
                    const detalle = {
                        mensaje: error.message,
                        status: response.status,
                        data: response.data
                    };
                    console.error("Error obteniendo la configuración de Qlik desde el backend:", detalle);
                    this.errorMessage = `No fue posible obtener la configuración del informe "${nombreInforme}" (${detalle.status || 's/n'}): ${JSON.stringify(detalle.data || detalle.mensaje)}`;
                    return false;
                }
            },
            async getAccessToken(){
                try{
                    console.log("Obteniendo Token desde Backend...");
                    let result = await this.$store.getters.api("qlik-auth/token", {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('token')}`
                        }
                    });
                    return result.data.access_token;
                }catch(error){
                    const response = error && error.response ? error.response : {};
                    const detalle = {
                        mensaje: error.message,
                        status: response.status,
                        data: response.data
                    };
                    console.error("Error obteniendo el Token desde el backend:", detalle);
                    this.errorMessage = `No fue posible obtener el token (${detalle.status || 's/n'}): ${JSON.stringify(detalle.data || detalle.mensaje)}`;
                    return null;
                }
            },
            limpiarEstadoQlikCacheado(){
                try{
                    [window.localStorage, window.sessionStorage].forEach(storage => {
                        const keys = [];
                        for (let i = 0; i < storage.length; i++) {
                            const key = storage.key(i);
                            if (key && /qlik/i.test(key)) keys.push(key);
                        }
                        keys.forEach(key => storage.removeItem(key));
                    });
                }catch(error){
                    console.warn("No fue posible limpiar el estado cacheado de Qlik:", error);
                }
            },
            loadQlikScript(){
                this.limpiarEstadoQlikCacheado();
                return new Promise((resolve, reject) => {
                    var qlik_embed_script = document.createElement('script');
                    qlik_embed_script.setAttribute('crossorigin', 'anonymous');
                    qlik_embed_script.setAttribute('type', 'application/javascript');
                    qlik_embed_script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@qlik/embed-web-components@1/dist/index.min.js');
                    qlik_embed_script.setAttribute('data-host', 'fga.us.qlikcloud.com');
                    qlik_embed_script.setAttribute('data-client-id', 'c8f57be594635f9872cc80f6bdeeb9c8');
                    qlik_embed_script.setAttribute('data-get-access-token', 'getAccessToken');
                    qlik_embed_script.setAttribute('data-auth-type', 'Oauth2');
                    qlik_embed_script.setAttribute('data-access-token-storage', 'session');
                    qlik_embed_script.onload = () => resolve();
                    qlik_embed_script.onerror = () => reject(new Error('No se pudo cargar el script de @qlik/embed-web-components'));
                    document.head.appendChild(qlik_embed_script);
                });
            },
            handleQlikError(event){
                const detail = event && event.detail ? event.detail : event;
                console.error("Error de qlik-embed contra fga.us.qlikcloud.com:", detail);
                const innerError = detail && detail.error ? detail.error : {};
                const mensaje = (detail && detail.message) || innerError.message || innerError || JSON.stringify(detail);
                this.errorMessage = mensaje;
            }
        },
        async mounted() {
            this.qlikHost = "fga.us.qlikcloud.com";
            window.getAccessToken = this.getAccessToken;

            const configuracionCargada = await this.cargarConfiguracionQlik();
            if (!configuracionCargada) {
                // errorMessage ya quedó seteado dentro de cargarConfiguracionQlik()
                return;
            }

            try{
                await this.loadQlikScript();
                await customElements.whenDefined('qlik-embed');
                const el = this.$refs.qlikEmbedEl;
                if (el){
                    el.addEventListener('error', this.handleQlikError);
                    el.addEventListener('first-render', () => console.log("Qlik embed renderizado correctamente"));
                }
            }catch(error){
                console.error("Error inicializando Qlik:", error);
                this.errorMessage = error.message;
            }
        },
        beforeDestroy(){
            const el = this.$refs.qlikEmbedEl;
            if (el){
                el.removeEventListener('error', this.handleQlikError);
            }
        }
    }
</script>

<style>
.container{
  position: relative;
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  margin-top: 40px;
  height: 70vh;
  min-height: 320px;
  width: 100%;
  margin-left: 0;
  padding: 0 5%;
}

.classic-app {
  flex: 1 1 100%;
  width: 100%;
  min-width: 0;
  border-radius: 3px;
  position: relative;
}

@media screen and (min-width: 576px) {
  .container {
    height: 75vh;
  }
}

@media screen and (min-width: 768px) {
  .container {
    height: 80vh;
    width: 90%;
    margin-left: 5%;
    padding: 0;
  }
}

@media screen and (min-width: 992px) {
  .container {
    height: 85vh;
  }
}

.qlik-error-banner {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  background: #fdecea;
  color: #611a15;
  border: 1px solid #f5c6cb;
  border-radius: 4px;
  padding: 10px 14px;
  font-size: 13px;
}

.qlik-error-banner pre {
  white-space: pre-wrap;
  word-break: break-word;
  margin: 4px 0 0 0;
}

qlik-embed::part(iframe) {
  pointer-events: none;
}

/* Intentar ocultar la barra dentro del iframe */
iframe {
  width: 100%;
  height: 100%;
}

iframe .qv-panel-sheet-toolbar,
iframe .qv-selection-toolbar,
iframe .qv-toolbar-right {
  display: none !important;
}

</style>

